// src/config/initialSettings.js

let circleFill = 'white';
let defaultLineStyle = { stroke: '#555', strokeWidth: 2 };
let defaultTextStyle = { fontFamily: 'Times, serif' };
let defaultLevelTextStyle = {};
let defaultCircleStyle = { fill: circleFill, stroke: '#000' };

let graphSettings = {
    defaultLanguage: 'gb',
    alternativeLanguages: ["gb","se"],
    standardLanguages: ["se", "gb"],
    defaultRootNodeId: "4", //process.env.NODE_ENV !== 'production' ? "10" : "4"
    minLevelRadiusDifference: 100,
    editMode: true,
    unavailableCircleStyle: { stroke: "#AAA" },
    unavailableLineStyle: { stroke: "#AAA" },
    unavailableTextStyle: { color: "#AAA" },
    levels: [
        { // 0
            name: "Domain",
            radius: 60,
            padding: 10,
            circleStyle: { ...defaultCircleStyle, strokeWidth: 2.5, fill: 'transparent', stroke: 'transparent' },
            fontSize: 320,
            textStyle: { ...defaultTextStyle, fontSize: "24px" },
            textLocation: "inside",
            lineStyle: { ...defaultLineStyle },
            showChangeRoot: true,
        },
        { // 1
            name: "Kingdom",
            radius: 30,
            padding: 5,
            circleStyle: { ...defaultCircleStyle },
            fontSize: 100,
            textStyle: { ...defaultTextStyle, fontSize: "10px" },
            levelTextStyle: { ...defaultLevelTextStyle },
            textLocation: "inside",
            lineStyle: { ...defaultLineStyle, stroke: 'transparent', strokeWidth: 0 },
            showChangeRoot: true,
        },
        { // 2
            name: "Phylum",
            radius: 26,
            padding: 5,
            circleStyle: { ...defaultCircleStyle },
            fontSize: 100,
            textStyle: { ...defaultTextStyle, fontSize: "10px" },
            levelTextStyle: { ...defaultLevelTextStyle },
            textLocation: "inside",
            lineStyle: { ...defaultLineStyle },
            showChangeRoot: true,
        },
        { // 3
            name: "Class",
            radius: 14,
            padding: 5,
            circleStyle: { ...defaultCircleStyle },
            fontSize: 80,
            textStyle: { ...defaultTextStyle, fontSize: "8px" },
            levelTextStyle: { ...defaultLevelTextStyle },
            textLocation: "parent_line",
            lineStyle: { ...defaultLineStyle },
        },
        { // 4
            name: "Order",
            radius: 8,
            padding: 5,
            circleStyle: { ...defaultCircleStyle },
            fontSize: 80,
            textStyle: { ...defaultTextStyle, fontSize: "8px" },
            levelTextStyle: { ...defaultLevelTextStyle },
            textLocation: "parent_line",
            lineStyle: { ...defaultLineStyle },
        },
        { // 5
            name: "SubOrder",
            radius: 5,
            padding: 5,
            circleStyle: { ...defaultCircleStyle },
            fontSize: 80,
            textStyle: { ...defaultTextStyle, fontSize: "8px" },
            levelTextStyle: { ...defaultLevelTextStyle },
            textLocation: "parent_line",
            lineStyle: { ...defaultLineStyle },
        },
        { // 6
            name: "Family",
            radius: 5,
            padding: 10,
            circleStyle: { ...defaultCircleStyle },
            fontSize: 80,
            textStyle: { ...defaultTextStyle, fontSize: "8px" },
            levelTextStyle: { ...defaultLevelTextStyle },
            textLocation: "parent_line",
            lineStyle: { ...defaultLineStyle },
        },
        { // 7
            name: "Genus", // TODO kursiv
            radius: 0,
            padding: 10,
            circleStyle: { ...defaultCircleStyle },
            fontSize: 80,
            textStyle: { ...defaultTextStyle, fontSize: "8px" },
            levelTextStyle: { ...defaultLevelTextStyle, fontStyle: "italic" },
            textLocation: "outside",
            lineStyle: { ...defaultLineStyle },
        },
        { // 8
            name: "Species", // TODO Kursiv, liten
            radius: 0,
            padding: 10,
            circleStyle: { ...defaultCircleStyle },
            fontSize: 80,
            textStyle: { ...defaultTextStyle, fontSize: "8px" },
            levelTextStyle: { ...defaultLevelTextStyle, textTransform: "lowercase", fontStyle: "italic" },
            textLocation: "outside",
            lineStyle: { ...defaultLineStyle },
        },
        { // 9
            name: "SubSpecies", // TODO Kursiv, liten
            radius: 0,
            padding: 10,
            circleStyle: { ...defaultCircleStyle },
            fontSize: 80,
            textStyle: { ...defaultTextStyle, fontSize: "8px" },
            levelTextStyle: { ...defaultLevelTextStyle, textTransform: "lowercase", fontStyle: "italic" },
            textLocation: "outside",
            lineStyle: { ...defaultLineStyle },
        },
        { // 10
            name: "SubSubSpecies", // TODO Kursiv, liten
            radius: 0,
            padding: 10,
            circleStyle: { ...defaultCircleStyle },
            fontSize: 80,
            textStyle: { ...defaultTextStyle, fontSize: "80px" },
            levelTextStyle: { ...defaultLevelTextStyle, textTransform: "lowercase", fontStyle: "italic" },
            textLocation: "outside",
            lineStyle: { ...defaultLineStyle },
        }
    ]
};

export default graphSettings;
